<template>
  <div>
    <ButtonSquare
      size="small"
      class="navigation-buttons__button"
      :imgSource="require('@/assets/icons-general/rotate_clockwise.svg')"
      @clicked="changeBearing('clockwise')"
    />
    <ButtonSquare
      size="small"
      class="navigation-buttons__button"
      :imgSource="require('@/assets/icons-general/rotate_counterclockwise.svg')"
      @clicked="changeBearing('counterClockwise')"
    />
  </div>
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
export default {
  name: 'BearingControl',
  components: {
    ButtonSquare
  },
  methods: {
    changeBearing(direction) {
      const currentBearing = this.$store.map.getBearing()
      const rotation = direction === 'counterClockwise' ? 5 : -5
      const animationDuration = 300
      this.$store.map.flyTo({
        bearing: currentBearing + rotation,
        curve: 0.5, // Lower value equals slower/smoother transition
        screenSpeed: 0.5,
        easing: function (t) {
          return t
        }, // Easing function for zoom speed
        duration: animationDuration
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-buttons__button {
  margin: 0px 0px 10px 0px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
